var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-auth"},[_c('div',{staticClass:"header-auth__content"},[_c('div'),_c('div',{staticClass:"header-auth__btn-container"},[_c('div',{staticClass:"header-auth__btn-title"},[_vm._v(_vm._s(_vm.title))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }